// extracted by mini-css-extract-plugin
export default {"container":"modelProducts_container__NpH-5","title":"modelProducts_title__pm+Jm"};